import React, { useState } from 'react';
import { Field } from 'redux-form';
import { formatRut } from '../helpers/utils';
import { FormInput, FormNumber, FormSelect } from './';

const relationship = [
  {
    name: 'Padres',
    value: 'Padres',
  },
  {
    name: 'Hijos',
    value: 'Hijos',
  },
  {
    name: 'Cónyuge',
    value: 'Conyuge',
  },
  {
    name: 'Herederos legales',
    value: 'Herederos-legales',
  },
  {
    name: 'Sobrinos',
    value: 'Sobrinos',
  },
  {
    name: 'Tíos',
    value: 'Tios',
  },
  {
    name: 'Hermanos',
    value: 'Hermanos',
  },
  {
    name: 'Suegros',
    value: 'Suegros',
  },
  {
    name: 'Nietos',
    value: 'Nietos',
  },
  {
    name: 'Abuelos',
    value: 'Abuelos',
  },
  {
    name: 'Tutor',
    value: 'Tutor',
  },
];

interface IChargeProps {
  index: number;
  chargesCount: number[];
}

export default function Plan(props: IChargeProps) {
  const { index, chargesCount } = props;
  const [name, setName] = useState('');
  const [percentage, setPercentage] = useState('');
  const changeName = (event: any) => setName(event.target.value);
  const changePercentage = (event: any) => setPercentage(event.target.value);

  return (
    <div className="row mt20">
      <div className="col-12">
        <h3 className={`${index + 1 > 1 ? 'border-top pt30' : ''}`}>
          {index === 0 && chargesCount.length === 1
            ? ' Beneficiario único'
            : `Beneficiario ${index + 1}`}
        </h3>
      </div>
      <div className="col-12">
        <div className="row">
          <div className="col-12 form-group col-sm-8">
            <label htmlFor={`charge-name-${index}`}>Nombre</label>
            <Field
              name={`charge-name-${index}`}
              placeholder="Camila Rocio Ramírez Herrera"
              component={FormInput}
              onChange={changeName}
              value={name}
            />
          </div>
          <div className="col-12 col-sm-4 form-group">
            <label htmlFor={`charge-documentNumber-${index}`}>Rut</label>
            <Field
              name={`charge-documentNumber-${index}`}
              type="text"
              placeholder="Ej 12.345.678-9"
              component={FormInput}
              normalize={formatRut}
            />
          </div>
          <div className="col-12 col-sm-4 form-group">
            <label htmlFor={`charge-relationship-${index}`}>
              Tipo parentesco
            </label>
            <Field
              name={`charge-relationship-${index}`}
              placeholder="Selecciona..."
              component={FormSelect}
              options={relationship}
            />
          </div>
          <div className="col-12 col-sm-4 form-group">
            <label htmlFor={`charge-birthdate-${index}`}>
              Fecha de nacimiento
            </label>
            <Field
              name={`charge-birthdate-${index}`}
              placeholder="31-12-2000"
              inputFormat="##-##-####"
              mask={['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a']}
              component={FormNumber}
            />
          </div>
          {chargesCount.length > 1 ? (
            <div className="col-12 col-sm-4 form-group">
              <label htmlFor={`charge-percentage-${index}`}>
                % de repartición
              </label>
              <Field
                name={`charge-percentage-${index}`}
                placeholder="Ej 20%"
                max="100"
                min="0"
                component={FormNumber}
                onChange={changePercentage}
                value={percentage}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
